export default "__VITE_PUBLIC_ASSET__b165238c__"